import React from 'react';
import TitlePage from './../../components/page/title';
import NavBar from './../../components/NavBar';
import Home from './../../screens/Home';
import { Button, Row, Col, Form, Image } from 'react-bootstrap';
import { gameElementService, podcastService, routeService, popupService } from '../../services';
import './GameElement.scss';
import toast from 'toasted-notes';
import queryString from 'query-string';
import { BADGE_TYPE_CONFIG, ALL_TYPE_FIELDS } from '../../constants/badgeTypes';

class GameElementEdit extends Home {
  constructor(props) {
    super(props);
    let params = queryString.parse(this.props.location.search);
    this.state = {
      gameElement: {
        title: "",
        image: "",
        shortSynopsis: "",
        longSynopsis: "",
        isBadge: false,
        isHint: false,
        banner: "",
        routeId: null,
        popup: null,
        numRecords: null,
        numSubscriptions: null,
        numDays: null,
        ranking: 0,
        moreInfo: "",
        requirements: "",
        podcastId: null,
        destinationTagId: null,
      },
      badgeType: "",
      imagePreviewUrl: "",
      bannerPreviewUrl: "",
      buttonVisible: true,
      idGameElement: params.id ? params.id : -1,
      podcasts: [],
      routes: [],
      destinationTags: [],
      popups: [],
    };

    if (this.state.idGameElement !== -1) {
      this.callSearch();
    }
    this.loadData();

    this.handlerUpload = this.handlerUpload.bind(this);
    this.handlerDelete = this.handlerDelete.bind(this);
    this.reactTags = React.createRef();
  }

  loadData() {
    podcastService.all((data) => data && this.setState({ podcasts: data }));
    routeService.all((data)   => data && this.setState({ routes: data }));
    podcastService.tagtype("DESTINATION", (data) => data && this.setState({ destinationTags: data }));
    popupService.all((data)   => data && this.setState({ popups: data }));
  }

  callSearch() {
    let callback = (data, error) => {
      if (data) {
        this.setState({
          gameElement: data,
          imagePreviewUrl: data.image,
          bannerPreviewUrl: data.banner,
          badgeType: this.inferBadgeType(data),
        });
      } else {
        const msg = "No se ha encontrado el elemento de juego";
        toast.notify(msg, { position: 'top', duration: 5000 });
        this.setState({ buttonVisible: false });
      }
    };
    gameElementService.one(this.state.idGameElement, callback);
  }

  inferBadgeType(data) {
    return Object.keys(BADGE_TYPE_CONFIG).find((type) => {
      const config = BADGE_TYPE_CONFIG[type];
      if (config.isHint) {
        if (!data.isHint) return false;
        return config.fields.some((field) => {
          const val = data[field.name];
          return field.isObject ? val != null : val != null && val > 0;
        });
      }
      if (!data.isBadge) return false;
      return config.fields.some((field) => {
        const val = data[field.name];
        return field.isObject ? val != null : val != null && val > 0;
      });
    }) || "";
  }

  buildPayload() {
    const { gameElement, badgeType } = this.state;
    const config = BADGE_TYPE_CONFIG[badgeType];
    const activeFields = config?.fields.map((f) => f.name) ?? [];

    const typeOverrides = {};
    ALL_TYPE_FIELDS.forEach((fieldName) => {
      typeOverrides[fieldName] = null;
    });

    activeFields.forEach((fieldName) => {
      typeOverrides[fieldName] = gameElement[fieldName];
    });

    return {
      ...gameElement,
      ...typeOverrides,
      isBadge: config ? config.isBadge : false,
      isHint:  config ? config.isHint  : false,
      type:    config ? config.backendType : null,
    };
  }

  
  handleChange(event) {
    const value = event.target.value;
    const name = event.target.name;
    const gameElement = { ...this.state.gameElement };

    const directFields = ["title", "shortSynopsis", "longSynopsis", "moreInfo", "requirements", "numRecords", "numSubscriptions", "ranking"];
    if (directFields.includes(name)) {
      gameElement[name] = value;
    } else if (name === "daysSinceRegistration") {
      gameElement.numDays = value;
    } else if (name === "banner") {
      gameElement.banner = value;
      this.setState({ bannerPreviewUrl: value });
    } else if (name === "image") {
      gameElement.image = value;
      this.setState({ imagePreviewUrl: value });
    } else if (name === "popupId") {
      gameElement.popup = value !== null && value !== ""  ? { id: value } : null;
    } else if (["routeId", "podcastId", "destinationTagId"].includes(name)) {
      gameElement[name] = value ? { id: value } : null;
    }

    this.setState({ gameElement });
  }

  validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocolo
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // nombre de dominio
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR dirección IP (v4)
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // puerto y ruta
      '(\\?[;&a-z\\d%_.~+\\/=-]*)?'+ // cadena de consulta
      '(\\#[-a-z\\d_]*)?$','i'); // fragmento
    return !!pattern.test(str);
  }

  handleTypeChange(event) {
    const badgeType = event.target.value;
    const gameElement = { ...this.state.gameElement };

    ALL_TYPE_FIELDS.forEach((field) => { gameElement[field] = null; });

    const config = BADGE_TYPE_CONFIG[badgeType];
    gameElement.isBadge = config ? config.isBadge : false;
    gameElement.isHint  = config ? config.isHint  : false;

    this.setState({ gameElement, badgeType });
  }

  handleClickSave(event) {
    const { title, banner } = this.state.gameElement;
    const { badgeType } = this.state;

    if (!badgeType) {
      toast.notify("Debes seleccionar un tipo de elemento", { position: 'top', duration: 5000 });
      return;
    }
    if (!title) {
      toast.notify("El título es obligatorio", { position: 'top', duration: 5000 });
      return;
    }
    if (!banner || !this.validURL(banner)) {
      toast.notify("La URL del banner no tiene un formato correcto", { position: 'top', duration: 5000 });
      return;
    }

    const config = BADGE_TYPE_CONFIG[badgeType];
    if (config) {
      for (const field of config.fields) {
        if (!field.required) continue;
        const val = this.state.gameElement[field.name];
        const isEmpty = field.isObject ? !val?.id : (val === null || val === undefined || val === '');
        if (isEmpty) {
          toast.notify(field.errorMsg, { position: 'top', duration: 5000 });
          return;
        }
      }
    }

    if (this.state.idGameElement !== -1) {
      this.callEdit();
    } else {
      this.callCreate();
    }
  }

  callCreate() {
    let callback = (data, error) => {
    if (data && data.data) {
      this.setState({ gameElement: data.data });
      window.location.href = "/gameelement?id=" + data.data.id;
    }
  };
  gameElementService.create(this.buildPayload(), callback);
  }

  callEdit() {
    let callback = (data, error) => {
      if (data && data.data) {
        const msg = "Se ha guardado correctamente";
        toast.notify(msg, { position: 'top', duration: 5000 });
      }
    };
    gameElementService.edit(this.state.idGameElement, this.buildPayload(), callback);
  }

  handlerUpload(image) {
    const gameElement = { ...this.state.gameElement };
    gameElement.image = image;
    this.setState({ gameElement });
  }

  handlerDelete() {
    const gameElement = { ...this.state.gameElement };
    gameElement.image = "";
    this.setState({ gameElement });
  }


  renderTypeField(field) {
    const { gameElement } = this.state;

    if (field.type === "number") {
      const inputName = field.name === "numDays" ? "daysSinceRegistration" : field.name;
      return (
        <Col sm="12" key={field.name}>
          <Form.Group>
            <Form.Label>{field.label}</Form.Label>
            <Form.Control
              type="number"
              name={inputName}
              value={gameElement[field.name] ?? ''}
              onChange={(e) => this.handleChange(e)}
            />
          </Form.Group>
        </Col>
      );
    }

    if (field.type === "select") {
      const options = this.state[field.dataKey] || [];
      const currentValue = gameElement[field.name]?.id || '';
      return (
        <Col sm="12" key={field.name}>
          <Form.Group>
            <Form.Label>{field.label}</Form.Label>
            <Form.Control
              as="select"
              name={field.name}
              value={currentValue}
              onChange={(e) => this.handleChange(e)}
            >
              <option value="">---</option>
              {options.map((opt, idx) => (
                <option key={idx} value={opt.id}>{opt[field.optionLabel]}</option>
              ))}
            </Form.Control>
          </Form.Group>
        </Col>
      );
    }

    return null;
  }
  render() {
    const { badgeType, gameElement } = this.state;
    const typeConfig = BADGE_TYPE_CONFIG[badgeType];
    const typeSelected = badgeType !== "";

    return (
      <>
        <NavBar user={this.state.user} callback={this.changeMenu} />
        <div className="main">
          <TitlePage title={this.state.idGameElement !== -1 ? "Editar elemento de juego" : "Nuevo elemento de juego"} newbutton={false} link="" />
          <Row>
            <Col sm="12">
              <Form.Group>
                <Form.Label>Título</Form.Label>
                <Form.Control type="text" name="title" value={gameElement.title} onChange={event => this.handleChange(event)} required />
              </Form.Group>
            </Col>
            <Col sm="12">
              <Form.Group>
                <Form.Label>Sinopsis corta</Form.Label>
                <Form.Control type="text" name="shortSynopsis" value={gameElement.shortSynopsis} onChange={event => this.handleChange(event)} />
              </Form.Group>
            </Col>
            <Col sm="12">
              <Form.Group>
                <Form.Label>Sinopsis larga</Form.Label>
                <Form.Control as="textarea" rows="3" name="longSynopsis" value={gameElement.longSynopsis} onChange={event => this.handleChange(event)} />
              </Form.Group>
            </Col>
            <Col sm="6">
              <Form.Label>Banner</Form.Label>
              <Form.Control type="text" name="banner" value={gameElement.banner} onChange={event => this.handleChange(event)} />
              {this.validURL(this.state.bannerPreviewUrl) && (
                <div className="paneImage">
                  <Image src={this.state.bannerPreviewUrl} alt="Preview" fluid />
                </div>
              )}
            </Col>
            <Col sm="6">
              <Form.Label>Image</Form.Label>
              <Form.Control type="text" name="image" value={gameElement.image} onChange={event => this.handleChange(event)} />
              {this.validURL(this.state.imagePreviewUrl) && (
                <div className="paneImage">
                  <Image src={this.state.imagePreviewUrl} alt="Preview" fluid />
                </div>
              )}
            </Col>
            <Col sm="12">
              <Form.Group>
                <Form.Label>Tipo de elemento</Form.Label>
                <Form.Control as="select" value={badgeType} onChange={event => this.handleTypeChange(event)}>
                  <option value="">-- Selecciona un tipo --</option>
                  {Object.entries(BADGE_TYPE_CONFIG).map(([key, config]) => (
                    <option key={key} value={key}>{config.label}</option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            {typeSelected && (
              <>
                <Col sm="6">
                  <Form.Group>
                    <Form.Label>Pop Up vinculado</Form.Label>
                    <Form.Control as="select" name="popupId" value={gameElement.popup?.id || ''} onChange={event => this.handleChange(event)}>
                      <option value="">---</option>
                      {this.state.popups.map((popup, idx) => (
                        <option key={idx} value={popup.id}>{popup.title}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col sm="6">
                  <Form.Group>
                    <Form.Label>Ranking</Form.Label>
                    <Form.Control type="number" name="ranking" value={gameElement.ranking} onChange={event => this.handleChange(event)} />
                  </Form.Group>
                </Col>
              </>
            )}

            {typeConfig && typeConfig.fields.map((field) => this.renderTypeField(field))}

            <Col sm="12">
              <Form.Group>
                <Form.Label>Más información</Form.Label>
                <Form.Control type="text" name="moreInfo" value={gameElement.moreInfo} onChange={event => this.handleChange(event)} />
              </Form.Group>
            </Col>
            <Col sm="12">
              <Form.Group>
                <Form.Label>Requerimientos</Form.Label>
                <Form.Control type="text" name="requirements" value={gameElement.requirements} onChange={event => this.handleChange(event)} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col className="text-right">
              <Button variant="default" onClick={() => window.location.href = "/gameelements"}>Cancelar</Button>
              {this.state.buttonVisible && (
                <Button variant="primary" onClick={event => this.handleClickSave(event)}>Guardar</Button>
              )}
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default GameElementEdit;
